// @ts-nocheck
import React, { useState } from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";
import style from "./PaymentHistroy.module.scss";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { getImageUrl } from "../../../commons/assets_path";
import { Loader } from "../Loaders/Loader";
import { PageLoader } from "../Loaders/PageLoader";
import { useTranslation } from "react-i18next";

const customStyles = {
  overlay: {
    zIndex: 1501,
    background: "rgba(34,34,34, 0.3)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 956,
    height: 565,
    width: "100%",
    borderRadius: 12,
    padding: "34px 80px",
  },
};

export const PaymentHistory = ({ payments, client }) => {
  const { t } = useTranslation();
  const [isModal, setIsModal] = useState<boolean>(false);
  const [id, setId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [fullPayments, setFullPayments] = useState([]);
  const [inProgress, setInProgress] = useState(true);

  const openModal = () => {
    setIsModal(true);
    init();
  };

  const closeModal = () => setIsModal(false);

  const getPayments = async () => {
    await axios
      .get(`/${client}/api_payments`, {
        params: {
          limit: 100,
        },
      })
      .then((res) => {
        setFullPayments(res.data);
      })
      .catch((_) => {
        return;
      });
  };

  const init = async () => {
    await getPayments();
    setInProgress(false);
  };

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between">
        <div className={`mb-3 ${style.paymentHistoryTitle}`}>{t("PaymentHistory.支払い履歴")}</div>
        <a href="#" className="my-3 align-self-end test-link-payment-list" onClick={openModal}>
          {t("PaymentHistory.すべて見る")}
        </a>
      </div>
      <div className={style.paymentHistoryWrap} style={{ height: "auto" }}>
        <div className={style.paymentHistoryItemsWrap}>
          <div className={style.paymentHistoryItems}>
            <div className={style.paymentHistoryNameWrap}>
              <div className={style.paymentHistoryName}>{t("PaymentHistory.名前")}</div>
            </div>
            <div className={style.paymentHistoryOtherWrap}>
              <div className={style.paymentHistoryOtherItem}>{t("PaymentHistory.発行日")}</div>
              <div className={style.paymentHistoryOtherItem}>{t("PaymentHistory.請求金額")}</div>
              <div className={style.paymentHistoryOtherItem}>{t("PaymentHistory.プラン")}</div>
              <div className={style.paymentHistoryStatus}>{t("PaymentHistory.ステータス")}</div>
            </div>
          </div>
        </div>
        {payments.map((payment, i) => (
          <div className={style.paymentHistoryValuesWrap} key={i}>
            <div className={style.paymentHistoryItems}>
              <div className={style.paymentHistoryNameWrap}>
                <a href={payment.invoice_pdf} className="mr-2">
                  <img src={getImageUrl("images/icons/pdf.svg")} width="30" height="30" />
                </a>
                {payment.description}
              </div>
              <div className={style.paymentHistoryOtherWrap}>
                <div className={style.paymentHistoryOtherItem}>{payment.date ? payment.date : "-"}</div>
                <div className={style.paymentHistoryOtherItem}>
                  {payment.currency_symbol}
                  {payment.amount_paid.toLocaleString()}
                </div>
                <div className={style.paymentHistoryOtherItem}>{payment.plan}</div>
                <div className={style.paymentHistoryStatus}>{payment.status}</div>
                <div>
                  <a href={payment.invoice_pdf}>
                    <img src={getImageUrl("images/icons/downloadBlack.svg")} alt="" width={20} height={20} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={isModal}
        onRequestClose={closeModal}
        style={customStyles}
        bodyOpenClassName="ReactModal__Body--open"
      >
        <h1 className={style.modalTitle}>{t("PaymentHistory.支払い履歴")}</h1>
        {!inProgress ? (
          <>
            {fullPayments.length ? (
              <div className={style.paymentHistoryWrap}>
                <div className={style.paymentHistoryItemsWrap}>
                  <div className={style.paymentHistoryItems}>
                    <div className={style.paymentHistoryNameWrap}>
                      <div className={style.paymentHistoryName}>{t("PaymentHistory.名前")}</div>
                    </div>
                    <div className={style.paymentHistoryOtherWrap}>
                      <div className={style.paymentHistoryOtherItem}>{t("PaymentHistory.日付")}</div>
                      <div className={style.paymentHistoryOtherItem}>{t("PaymentHistory.金額")}</div>
                      <div className={style.paymentHistoryOtherItem}>{t("PaymentHistory.プラン")}</div>
                      <div className={style.paymentHistoryStatus}>{t("PaymentHistory.ステータス")}</div>
                    </div>
                  </div>
                </div>
                {fullPayments.map((payment, i) => (
                  <div className={style.paymentHistoryValuesWrap} key={i}>
                    <div className={style.paymentHistoryItems}>
                      <div className={style.paymentHistoryNameWrap}>
                        <a href={payment.invoice_pdf} className="mr-2">
                          <img src={getImageUrl("images/icons/pdf.svg")} width="30" height="30" />
                        </a>
                        {payment.description}
                      </div>
                      <div className={style.paymentHistoryOtherWrap}>
                        <div className={style.paymentHistoryOtherItem}>{payment.date ? payment.date : "-"}</div>
                        <div className={style.paymentHistoryOtherItem}>
                          {payment.currency_symbol}
                          {payment.amount_paid.toLocaleString()}
                        </div>
                        <div className={style.paymentHistoryOtherItem}>{payment.plan}</div>
                        <div className={style.paymentHistoryStatus}>{payment.status}</div>
                        <a href={payment.invoice_pdf}>
                          <img src={getImageUrl("images/icons/downloadBlack.svg")} alt="" width={20} height={20} />
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <span>{t("PaymentHistory.支払い履歴はありません。")}</span>
            )}
          </>
        ) : (
          <PageLoader loadingHeight={"360px"} />
        )}
      </Modal>
    </div>
  );
};

PaymentHistory.propTypes = {
  payments: PropTypes.array,
  client: PropTypes.string,
};
